<!-- 制作印章 -->
<template>
    <page-container class="current-seal"
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item><a>印章管理</a></el-breadcrumb-item>
        </el-breadcrumb>

        <div class="curr-seal-box">
            <div class="header">
                <el-button class="grey-text small-font"
                           type="text"
                           v-if="!hideNavigate"
                           @click="$router.push('/home')">&lt; 返回上一页</el-button>
            </div>
            <div class="etl-seal-container" v-loading="loading">
                <p class="status-prompt">{{statusPrompt}}</p>

                <div v-if="hasSeal" style="width: 660px;margin: 0 auto;">
                    <div class="etl-seal-item" v-for="seal in sealList" :key="seal.name">
                        <div class="seal-image transform-center">
                            <div class="img-wrapper">
                                <img :src="seal.image"
                                alt="">
                            </div>
                        </div>
                        <div class="seal-info">
                            <h4 class="title">{{seal.name}}</h4>
                        </div>
                    </div>
                </div>
                <el-button v-if="emptyMouldAndSeal || hasMould" @click="goMouldManage"> {{ btnPrompt }} </el-button>
            </div>
        </div>
    </page-container>
</template>

<script>
import { mapGetters } from 'vuex';
import PageContainer from '../../components/container.vue';
import wholeMould from '../mould/mouldData';

export default {
    name: 'CurrentSeal',
    components: { PageContainer },
    data () {
        return {
            sealList: [],
            loading: false,
            mouldList: []
        };
    },
    props: {
        hideNavigate: Boolean
    },
    inject: ['app'],
    computed: {
        ...mapGetters(['isEtl']),
        quser () {
            return this.$store.getters.quser;
        },
        // 无印模无印章
        emptyMouldAndSeal() {
            return !this.mouldList.length && !this.sealList.length;
        },
        // 拥有部分印模，无印章
        hasMould() {
            return this.mouldList.length && !this.sealList.length;
        },
        // 拥有所有印模
        hasAllMould() {
            return Object.keys(wholeMould).every( key => this.mouldList.find( item => item.mouldType === key )) && !this.sealList.length;
        },
        // 有印章以及部分印模
        hasMouldAndSeal() {
            return this.sealList.length && this.sealList.length !== 4;
        },
        // 如果存在印章就展示
        hasSeal() {
            return this.sealList.length;
        },
        mouldName() {
            return this.mouldList.map( item => `[${wholeMould[item.mouldType]}]`).join('、');
        },
        // 未拥有的印章
        sealName() {
            return Object.keys(wholeMould).filter( key => !this.sealList.find( mould => mould.sealType === key) ).map( item =>  `[${wholeMould[item]}]`).join('、');
        },
        areaType() {
            return this.$store.getters.system.areaType;
        },
        isUkeyLogin() {
            return this.$store.getters.isLP && !this.$store.getters.isEtl;
        },
        statusPrompt() {
            return this.emptyMouldAndSeal ?
                '暂未申请印模' :
                this.hasMould ?
                    `你已申请${this.mouldName}印模，前往电子营业执照小程序或APP进行印章的领取` :
                    this.hasMouldAndSeal ?  `你还未领用${this.sealName}，完成印模申请后前往电子营业执照小程序或APP进行印章的领取`:
                        this.hasAllMould ? '你已完成所有印模申请，前往电子营业执照小程序或APP进行印章的领取' : '';
        },
        btnPrompt() {
            return this.emptyMouldAndSeal ? '前往印模管理申请印模' : '继续申请其他印模';
        }
    },
    mounted () {
        this.loading = true;
        if (this.areaType == 'MHQ' && this.isUkeyLogin) {
            this.wholeMould = {
                ...this.wholeMould,
                '06': '业务章',
            };
        }
        setTimeout(() => {
            this.getSealList();
            this.ownedmouldQuery();
        }, 4000);
    },
    methods: {
        goMouldManage() {
            if (this.$route.name === 'PersonalCenter') {
                location.href = '/personal/center?tab=mould';
                return;
            }
            this.$router.push({name: 'mould'});
        },

        // 获取已拥有的印模
        async ownedmouldQuery() {
            try {
                const resp = await this.axios({
                    url: '/seal/mould/query',
                    method: 'GET',
                });
                const { data } = resp;
                if(data.code === 0) {
                    this.mouldList = data.result;
                }
            } catch (error) {
                console.log(error);
            }

        },
        async getSealList () {
            try {
                this.loading = true;
                const res = await this.axios.get('/seal/query/etl/seals');
                if (res.data.code === 0) {
                    const list = [];
                    res.data.result.map(seal => {
                        list.push(this.formatSealInfo(seal));
                    });
                    this.sealList = list;
                } else {
                    this.$message.error(res.data.message);
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        formatSealInfo (seal) {
            const image = seal.sealPic || seal.picData || seal.pic_data;
            const name = seal.sealName || seal.seal_name;
            const status = seal.sealStatus || seal.seal_status || seal.status;
            return {
                image: `data:image/png;base64,${image}`,
                name,
                status,
                originData: seal,
                sealType: seal?.sealType ?? '',
            };
        },
    }
};
</script>

<style lang="less" scoped>
.status-prompt {
    margin-bottom: 12px;
}
.current-seal {
    .curr-seal-box {
        padding: 15px 30px 30px;
        .seal-container {
            min-height: 300px;
        }
    }
    .header {
        margin-bottom: 10px;
    }
    .etl-seal-container {
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .etl-seal-item {
            width: 300px;
            display: inline-block;
            margin-left: 30px;
            margin-top: 30px;
            border: 1px solid #efefef;
            vertical-align: top;
            .seal-image {
                height: 240px;
                padding: 20px;
                .img-wrapper {
                    width: 100%;
                    display: flex;
                    padding: 30px;
                    justify-content: center;
                    align-items: center;
                }
            }
            .title {
                line-height: 22px;
                text-align: center;
            }
        }
    }
}
</style>


